import { DOCUMENT_ACCEPT, fileExtension } from '@/services/documents/uploadPolicy'

/**
 * What the composer's file picker offers.
 *
 * Images are attachable but not indexable — they are named in the prompt and
 * never posted to the document pipeline, which only ever answered 415. Anything
 * outside both sets is rejected in the input handler, because `accept` is only
 * a hint (drag-and-drop and "All Files" bypass it).
 */
export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'gif']

export const COMPOSER_ACCEPT = [
  DOCUMENT_ACCEPT,
  ...IMAGE_EXTENSIONS.map((ext) => `.${ext}`),
].join(',')

export function isImageFile(file) {
  if (typeof file?.type === 'string' && file.type.startsWith('image/')) return true
  return IMAGE_EXTENSIONS.includes(fileExtension(file?.name))
}
